import { AutocompleteResponse, LocationState } from "@core/entities";
import { AdapterUi } from "@core/store/adapters/global.adapter";
import { createAction, props } from "@ngrx/store";

export enum LocationAction {
  Empty = "[LOCATION] Empty",
  ClearAll = "[LOCATION] Clear location state",
  UiLocation = "[LOCATION] UI Location",
  SetAutocompleteResponses = "[LOCATION] Set Autocomplete Responses",
  GetAutocompleteResponses = "[LOCATION] Get Autocomplete Responses",
  SetDetailResponse = "[LOCATION] Set Detail Response",
}

export const clearAll = createAction(LocationAction.ClearAll);
export const Empty = createAction(LocationAction.Empty);
export const uiLocation = createAction(LocationAction.UiLocation, props<{ ui: Array<AdapterUi<LocationState["ui"]>> }>());
export const setAutocompleteResponses = createAction(
  LocationAction.SetAutocompleteResponses,
  props<{ suggestions: AutocompleteResponse[] }>()
);
export const getAutocompleteResponses = createAction(
  LocationAction.GetAutocompleteResponses,
  props<{ input: string; lat: number; lng: number; retailerId: number }>()
);
export const setDetailResponse = createAction(LocationAction.SetDetailResponse, props<{ details: LocationState["detailResult"] }>());
